type PermissionUser =
  | {
      isAdmin?: boolean;
      is_admin?: boolean;
      permissions?: string[];
    }
  | null
  | undefined;

export function hasPermissions(
  user: PermissionUser,
  permissions: string[],
): boolean {
  if (!user) {
    return false;
  }

  if (user.isAdmin || user.is_admin) {
    return true;
  }

  return permissions.every((permission) =>
    user.permissions?.includes(permission),
  );
}
